import { Component, Input, OnInit } from '@angular/core'
import { SpritePositionService } from 'src/app/core/services/sprite-position.service'
import { DetailsModel } from 'src/app/shared/models/details.model'
import { SpriteImageComponent } from 'src/app/shared/components/sprite-image/sprite-image.component'

@Component({
  selector: 'app-details-signs',
  templateUrl: './details-signs.component.html',
  standalone: false,
})
export class DetailsSignsComponent implements OnInit {
  @Input() details!: Map<string, DetailsModel>
  @Input() zoomLevel: number = 12

  ngOnInit(): void {}
}
